import React, { useRef, useLayoutEffect } from "react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import "../styles/teamPhotos.css";

gsap.registerPlugin(ScrollTrigger);

const TeamPhotos: React.FC = () => {
    const sectionRef = useRef<HTMLDivElement | null>(null);
    const trackRef = useRef<HTMLDivElement | null>(null);

    useLayoutEffect(() => {
        if (!sectionRef.current || !trackRef.current) return;

        const ctx = gsap.context(() => {
            const section = sectionRef.current!;
            const track = trackRef.current!;

            const totalScroll = track.scrollWidth - section.offsetWidth;

            gsap.to(track, {
                x: () => -totalScroll,
                ease: "none",
                scrollTrigger: {
                    trigger: section,
                    start: "top top",
                    end: () => `+=${totalScroll}`,
                    scrub: 1,
                    pin: true,
                    pinSpacing: true,
                    anticipatePin: 1,
                    fastScrollEnd: true,
                    invalidateOnRefresh: true,
                },
            });
        }, sectionRef);

        return () => ctx.revert();
    }, []);

    return (
        <section
            ref={sectionRef}
            className="scroll-container history"
            id="history"
        >
            <div ref={trackRef} className="timeline">

                <article className="yearHero">2019</article>

                <article className="moment">
                    <img src="/images/2019.png" />
                    <div className="caption">
                        <h3>The team was founded</h3>
                        <p>a bunch of text describing this year</p>
                    </div>
                </article>

                <article className="yearHero">2021</article>

                <article className="moment">
                    <img src="/images/2021.png" />
                    <div className="caption">
                        <h3>First Time in Silverstone</h3>
                        <p>a bunch of text describing this year</p>
                    </div>
                </article>

                <article className="yearHero">2022</article>

                <article className="moment">
                    <img src="/images/2022.png" />
                    <div className="caption">
                        <h3>Second time in Silverstone</h3>
                        <p>a bunch of text describing this year</p>
                    </div>
                </article>

                <article className="yearHero">2024</article>

                <article className="moment">
                    <img src="/images/2024.png" />
                    <div className="caption">
                        <h3>Second time in Silverstone</h3>
                        <p>a bunch of text describing this year</p>
                    </div>
                </article>

                <article className="yearHero">2025</article>

                <article className="moment">
                    <img src="/images/2025.png" />
                    <div className="caption">
                        <h3>Second time in Silverstone</h3>
                        <p>a bunch of text describing this year</p>
                    </div>
                </article>

                <article className="yearHero">2026</article>

            </div>
        </section>
    );
};

export default TeamPhotos;
